// A booking's email is the customer's identity: their sign-in is matched
// against what the tickets carry. Saving it trimmed and lowercased, the way the
// backend stores a new booking, keeps a recapitalised or pasted copy from
// reading as a different account. Forms validated by yup get this from the
// schema (`.trim().lowercase()`); this helper is for values read outside it,
// such as `getValues()` or a plain input. A missing email becomes "".
export const normalizeEmail = (email?: string | null): string =>
  (email ?? "").trim().toLowerCase();
